module.exports = __webpack_public_path__ + "img/CIOToday.ea2c2a5e.jpg";